import React from 'react';

interface MobileListItemWithChildrenProps {
  count: number;
  item;
  level: number;
  container;
  backID;
}

export const MobileListItemWithChildren = ({
  count,
  item,
  level,
  container,
  backID,
}: MobileListItemWithChildrenProps) => {
  const text = item.Name ? item.Name : item.Title;
  const urlSegment = item.UrlSegment;

  const handleItemClick = (event) => {
    const nextLevel = level + 1;
    const el = document.getElementById(
      `mobile-mm-${container}-${nextLevel}-${event.currentTarget.id}`
    );
    if (el) {
      el.classList.remove('hidden');
      el.classList.forEach((className) => {
        if (className.startsWith('move')) {
          el.classList.remove(className);
          el.classList.add('move-from-left');
        }
      });
      const child = el.querySelector('.mobile-mm-header-title');
      const backChild = el.querySelector('.mobile-mm-header-back');
      if (backChild && backID) backChild.setAttribute('data-mm-mobileback-id', backID);
      if (child) {
        if (urlSegment && urlSegment.length) {
          child.innerHTML = `<a href=${urlSegment} style="text-decoration:underline;font-weight:bold;padding:0px">${text}</a>`;
        } else {
          child.innerHTML = text;
        }
      }
    }
  };

  return (
    <li
      onClick={handleItemClick}
      className='l-header-mobile-menu-item link elsetest'
      id={count.toString()}
      data-mobile-menus-id={count}
    >
      <span>{text}</span>
      <i className='icon-angle-right' />
    </li>
  );
};
